var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import PurchaseRefundForUpperSupService from '../../../api/PurchaseRefundForUpperSupService';
import GoodService from "../../../api/GoodService";
import VueDialog from "../../../interface/IVueDialog";
import AddGoodTable from './AddGoodTable.vue';
var EActiveType;
(function (EActiveType) {
    EActiveType["UNSELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.periodicList = [];
        _this.total = 0;
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.supplier_upper_id = '';
        _this.organ_id = '';
        _this.depot_id = '';
        _this.order_sub_type = '';
        _this.upper_warehouse_order_id = '';
        _this.loading = false;
        _this.categoryData = [];
        _this.formData = {
            goods_type_ids: null,
            keyword: ''
        };
        return _this;
    }
    AddDialog.prototype.watchActiveName = function (val, oldVal) {
        var _this = this;
        if (val === EActiveType.SELECTED) {
            this.setSelected();
        }
        else {
            setTimeout(function () {
                var gridTable = _this.$refs.grid.$refs.table;
                _this.selectedList.forEach(function (good, index) {
                    _this.$nextTick(function () {
                        _this.$refs.grid.$refs.table.toggleRowSelection(good, true);
                    });
                    var item = _.find(_this.unSelectList, function (current) { return current.goods_format_id === good.goods_format_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item, true);
                    });
                });
            });
        }
    };
    AddDialog.prototype.created = function () {
        this.goodService = GoodService.getInstance();
        this.purchaseRefundForUpperSupService = PurchaseRefundForUpperSupService.getInstance();
        this.selectedList = [];
        this.getCategory();
        this.getGoodList();
    };
    AddDialog.prototype.goodsTypeSelect = function (node) {
        this.formData.goods_type_ids = node.goods_type_id;
        this.search();
    };
    AddDialog.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getIds = function (arr, key) {
        if (!this.purchasers)
            return null;
        return _.reduce(arr, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    AddDialog.prototype.getGoodList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.loading = true;
        var goods_format_ids;
        if (this.added_goods_format_ids && this.added_goods_format_ids.length) {
            goods_format_ids = this.added_goods_format_ids;
        }
        else {
            goods_format_ids = (this.addedDatas || []).map(function (item) {
                return item.goods_format_id;
            });
        }
        var sort_field = this.filter_order ? this.filter_order[0] : null;
        var sort_type = this.filter_order ? this.filter_order[1] : null;
        if (sort_field === 'purchase_unit_name') {
            sort_field = 'purchase_unit_id';
        }
        else if (sort_field === 'goods_type_name') {
            sort_field = 'goods_type_id';
        }
        else if (sort_field === 'goods_code') {
            sort_field = 'supplier_goods_code';
        }
        else if (sort_field === 'goods_name') {
            sort_field = 'supplier_goods_name';
        }
        else if (sort_field === 'order_remaining_stock') {
            sort_field = 'order_remaining_stock';
        }
        var params = {
            goods_type_ids: this.formData.goods_type_ids,
            keyword: this.formData.keyword,
            notin_goods_format_ids: (goods_format_ids || []).join(','),
            supplier_upper_id: this.supplier_upper_id,
            organ_id: this.organ_id,
            depot_id: this.depot_id,
            order_sub_type: this.order_sub_type,
            order_id: this.upper_warehouse_order_id,
            sort_field: sort_field,
            sort_type: sort_type,
        };
        this.purchaseRefundForUpperSupService.getGoodsList(Object.assign({}, params, pager)).then(function (res) {
            if (res.data.success) {
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            _this.loading = false;
        }, function (err) {
            _this.$message.error(err.message);
            _this.loading = false;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            _this.loading = false;
        });
    };
    AddDialog.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        console.log('selectChange====>', rows, currentRow, isSelectAll);
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'goods_format_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.goods_format_id === currentRow.goods_format_id; })) {
            _.remove(this.selectedList, function (good) { return good.goods_format_id === currentRow.goods_format_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.goods_format_id === good.goods_format_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddDialog.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid && this.$refs.grid.$refs.table;
        if (isUnSelFresh && gridTable) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid && this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid && _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_format_id === good.goods_format_id; });
                    _this.$nextTick(function () {
                        gridTable && gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddDialog.prototype.search = function (filter_order) {
        if (filter_order) {
            this.filter_order = filter_order;
        }
        this.getGoodList();
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        var data = _.uniqBy(this.selectedList.concat(this.addedDatas), 'goods_format_id');
        data = data.map(function (item) {
            return __assign({}, item, { order_detail_warehouse_amount: item.order_detail_amount, order_detail_amount: item.order_detail_amount, order_detail_uprice: item.order_detail_uprice || item.goods_price, order_detail_tax_rate: item.order_detail_tax_rate || item.tax_rate || 0 });
        });
        this.$emit("submit", data);
        this.close();
    };
    AddDialog.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    __decorate([
        Watch('activeName')
    ], AddDialog.prototype, "watchActiveName", null);
    AddDialog = __decorate([
        Component({
            components: {
                'add-good-table': AddGoodTable
            },
            computed: {
                isMultiple: function () {
                    return _.uniqBy(this.purchasers, 'business_id').length > 1;
                }
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
